import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/firmware-landing/enCopy";

const FirmwareDevelopmentCompanyPage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/firmware-development-company",
      lang: "en",
      ogLocale: "en_US",
      structuredData: copy.structuredData,
      alternatePaths: {
        pl: "/programowanie-firmware-ble",
        en: "/firmware-development-company",
        xDefault: "/programowanie-firmware-ble",
      },
    }}
    alternateLanguage={{
      href: "/programowanie-firmware-ble",
      label: "PL",
    }}
    navbarCopy={copy.navbarCopy}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default FirmwareDevelopmentCompanyPage;
